import type { RequestTypeIssueSecurityStatus } from '@atlassian/jira-servicedesk-ticket-types-store/src/common/types.tsx';
import type { RequestTypeIssueSecurityResult } from '../../services/load-issue-security/types.tsx';
import type { RequestTypeIssueSecurityState } from './types.tsx';

export const isDefaultNotAllowed = ({
	isRequired,
	defaultSecurityLevelId,
}: RequestTypeIssueSecurityResult): boolean => isRequired || !defaultSecurityLevelId;

export const isMisconfigured = (issueSecurityStatus: RequestTypeIssueSecurityStatus): boolean =>
	issueSecurityStatus === 'MISCONFIGURED_REQUIRED_FIELD' ||
	issueSecurityStatus === 'MISCONFIGURED_MISSING_LEVEL';

export const isMisconfiguredMissingLevel = ({
	selectedSecurityLevelId,
	securityLevels,
}: RequestTypeIssueSecurityResult): boolean =>
	!!selectedSecurityLevelId && !securityLevels.some(({ id }) => id === selectedSecurityLevelId);

export const isMissingValueForRequiredField = ({
	isRequired,
	selectedSecurityLevelId,
}: RequestTypeIssueSecurityResult): boolean => isRequired && !selectedSecurityLevelId;

export const isMissingValueForSelectOption = ({
	securityLevelOption,
	defaultSecurityLevelId,
	selectedSecurityLevelId,
}: RequestTypeIssueSecurityState): boolean =>
	securityLevelOption === 'SELECT' && !!defaultSecurityLevelId && !selectedSecurityLevelId;
